module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/transaction-grid/transaction-grid.component.css
// module id = ./src/app/finance/transaction-grid/transaction-grid.component.css
// module chunks = main